import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import HOME_MARKUP from "./homeMarkup";
import "./home.css";

// Markup is also injected into build/index.html by scripts/prerender.js
export default function Home() {
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const root = ref.current;
    const onClick = (e) => {
      const btn = e.target.closest(".t-btn");
      if (btn) {
        const track = root.querySelector(".t-track");
        const slide = track.querySelector(".t-slide");
        const dir = Number(btn.dataset.dir);
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
        if (dir > 0 && atEnd) track.scrollTo({ left: 0, behavior: "smooth" });
        else if (dir < 0 && track.scrollLeft <= 5) track.scrollTo({ left: track.scrollWidth, behavior: "smooth" });
        else track.scrollBy({ left: dir * (slide.offsetWidth + 20), behavior: "smooth" });
        return;
      }
      const play = e.target.closest(".t-play");
      if (play) {
        const frame = document.createElement("iframe");
        frame.src = play.dataset.src;
        frame.title = play.dataset.title;
        frame.allow = "autoplay; encrypted-media";
        frame.allowFullscreen = true;
        play.replaceWith(frame);
        return;
      }
      const link = e.target.closest("a[href^='/']");
      if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        navigate(link.getAttribute("href"));
        window.scrollTo(0, 0);
      }
    };
    root.addEventListener("click", onClick);
    return () => root.removeEventListener("click", onClick);
  }, [navigate]);

  return (
    <div
      ref={ref}
      className="mh-home"
      data-testid="home-page"
      dangerouslySetInnerHTML={{ __html: HOME_MARKUP }}
    />
  );
}
